import { URLS } from "Common/urls";
import { usePlatform } from "hooks/UsePlatform";
import { useContext, createContext, useState, useEffect } from "react";
import RestService from "Services/RestService";
import { StorageProvider } from "Utils/data";
import { getTimeZone } from "Utils/date";

const AppContext = createContext()

const SELECTED_SUPPLIER = "atease.selected_supplier"
const SELECTED_BRANCH = "atease.selected_branch"
const APP_INSTALL_SKIPPED = "atease.app_install_skipped"

const AppProvider = ({ children }) => {

    const [isLoading, showLoader] = useState(false)
    const [shouldReload, setReload] = useState(false)
    const [selectedSupplier, setSelectedSupplier] = useState(StorageProvider.get(SELECTED_SUPPLIER) ?? null)
    const [selectedBranch, setSelectedBranch] = useState(StorageProvider.get(SELECTED_BRANCH) ?? null)
    const [appInstalledSkipped, setAppInstalledSkippedContext] = useState(StorageProvider.get(APP_INSTALL_SKIPPED) ? StorageProvider.get(APP_INSTALL_SKIPPED) === true : false)
    const [showSelectSupplier, setShowSelectSupplier] = useState(false)
    const [showSelectBranch, setShowSelectBranch] = useState(false)
    const platform = usePlatform()
    const [key, setKey] = useState(0)

    const addAccessLog = (clientCode) => {
        RestService.put(URLS.SUPPLIER_ACCESS_LOG, {
            clientCode,
            type: "WEB",
            platform: platform,
            timezone: getTimeZone()
        })
            .then(({ statusCode, data }) => {
            }).catch(error => {
                console.error(error)
            })
    }

    useEffect(() => {
        if (platform !== 'Unknown' && selectedBranch && selectedSupplier && selectedSupplier.clientcode) {
            addAccessLog(selectedSupplier.clientcode)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSupplier, selectedBranch, platform])

    return (
        <AppContext.Provider value={{
            key,
            isLoading,
            showLoader: () => showLoader(true),
            hideLoader: () => showLoader(false),
            shouldReload,
            setReload,
            showSelectSupplier,
            setShowSelectSupplier,
            showSelectBranch,
            setShowSelectBranch,
            selectedSupplier,
            selectedBranch,
            addAccessLog,
            setSupplier: (supplier) => {
                setShowSelectSupplier(false)
                setShowSelectBranch(true)
                if (supplier && (!selectedSupplier || supplier.clientcode !== selectedSupplier.clientcode)) {
                    setSelectedSupplier(supplier)
                    setShowSelectBranch(true)
                    if (supplier) {
                        StorageProvider.set(SELECTED_SUPPLIER, supplier)
                        // addAccessLog(supplier.clientcode)
                    } else {
                        StorageProvider.remove(SELECTED_SUPPLIER)
                    }
                } else if (supplier) {
                    setSelectedSupplier(supplier)
                    StorageProvider.set(SELECTED_SUPPLIER, supplier)
                } else if (!supplier) {
                    setSelectedSupplier(supplier)
                    if (supplier) {
                        StorageProvider.set(SELECTED_SUPPLIER, supplier)
                    } else {
                        StorageProvider.remove(SELECTED_SUPPLIER)
                    }
                }
            },
            setBranch: (branch) => {
                setShowSelectBranch(false)
                if (!branch || !selectedBranch || (branch.custcode !== selectedBranch.custcode)) {
                    setSelectedBranch(branch)
                    if (branch) {
                        StorageProvider.set(SELECTED_BRANCH, branch)
                        // window.location.reload(true)
                        setKey(prevKey => prevKey + 1)
                    } else {
                        StorageProvider.remove(SELECTED_BRANCH)
                    }
                } else if (branch) {
                    setSelectedBranch(branch)
                    StorageProvider.set(SELECTED_BRANCH, branch)
                }
            },
            appInstalledSkipped,
            setAppInstalledSkipped: (skipped) => {
                StorageProvider.set(APP_INSTALL_SKIPPED, skipped)
                setAppInstalledSkippedContext(skipped)
            },
        }}>
            {children}
        </AppContext.Provider>
    )
}

const useAppContext = () => {
    const {
        key,
        isLoading,
        showLoader,
        hideLoader,
        shouldReload,
        setReload,
        selectedSupplier,
        selectedBranch,
        setSupplier,
        setBranch,
        showSelectSupplier,
        setShowSelectSupplier,
        showSelectBranch,
        setShowSelectBranch,
        addAccessLog,
        appInstalledSkipped,
        setAppInstalledSkipped,
    } = useContext(AppContext)

    return {
        key,
        isLoading,
        showLoader,
        hideLoader,
        shouldReload,
        setReload,
        selectedSupplier,
        selectedBranch,
        setSupplier,
        setBranch,
        showSelectSupplier,
        setShowSelectSupplier,
        showSelectBranch,
        setShowSelectBranch,
        addAccessLog,
        appInstalledSkipped,
        setAppInstalledSkipped,
        flags: {
            showMRP: selectedSupplier ? Number(selectedSupplier.flag_show_mrp || '0') === 1 : false,
            showDealerPrice: selectedSupplier ? Number(selectedSupplier.flag_show_dealer_price || '0') === 1 : false,
            showLedger: selectedSupplier ? Number(selectedSupplier.flag_show_ledger || '0') === 1 : false,
            stockVisibility: selectedSupplier ? Number(selectedSupplier.flag_stock_visibility || '0') : 0,
        },
    }
}

export { AppProvider, useAppContext }